<template>
	<div>
		<el-tree ref="tree" :data="data" show-checkbox node-key="id" :props="defaultProps"> </el-tree>
	</div>
</template>

<script>
	import permissionService from '@/service/permissionService'
	export default {
		data() {
			return {
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label',
				},
			}
		},
		props: {
			selected: {
				type: Array,
			},
		},
		watch: {
			selected: {
				handler: function(newVal, oldVal) {
					console.log('selected', newVal)
					var checkedKeys = []
					if (newVal) {
						if (newVal.length > 0) {
							checkedKeys = this.selected.map(t => t._id.$oid)
						}
					}

					this.$refs.tree.setCheckedKeys(checkedKeys)
				},
				deep: true,
			},
		},
		methods: {
			getCheckedKeys() {
				return this.$refs.tree.getCheckedKeys()
			},
			setCheckedKeys(newVal) {
				var checkedKeys = []
				if (newVal) {
					if (newVal.length > 0) {
						checkedKeys = this.selected.map(t => t._id.$oid)
					}
				}

				this.$refs.tree.setCheckedKeys(checkedKeys)
			},
		},
		created() {
			permissionService.getMenuTree().then(res => {
				this.data = res
				this.setCheckedKeys(this.selected)
			})
		},
	}
</script>

<style></style>
